import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterExportTypes',
    standalone: true
})
export class FilterExportTypesPipe implements PipeTransform {
    transform(items: any[], filter: string, propName: string): any {
        if (!items || !filter) return items;
        return items.filter(item => item[propName].toLowerCase().includes(filter.toLowerCase()));
    }
}
